
import { computed, defineComponent, ref, SetupContext, PropType } from 'vue';
export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    extraText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String as PropType<'blue' | 'gray'>,
      default: 'blue',
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    const prefixCls = ref('my-button');
    const getClasses = computed(() => ({
      wrap: [`${prefixCls.value}`, props.disabled && `${prefixCls.value}_disabled`],
      body: [
        `${prefixCls.value}-body`,
        props.theme === 'gray' && `${prefixCls.value}-body_gray`,
        props.disabled && `${prefixCls.value}-body_disabled`,
      ],
      title: [`${prefixCls.value}-txt`, props.disabled && `${prefixCls.value}-txt_disabled`],
      extraText: [`${prefixCls.value}-extraText`, props.disabled && `${prefixCls.value}-extraText_disabled`],
    }));

    /** 对外响应的事件 */
    const listener = (event: unknown) => {
      if (!props.disabled) {
        context.emit('click', event);
      }
      return null;
    };
    return { getClasses, listener };
  },
});
